<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-tabs v-model="activeName" class="tab_box">
        <el-tab-pane label="总体情况" name="all">
          <all v-if="activeName === 'all'"></all>
        </el-tab-pane>
        <el-tab-pane label="分项指标" name="subItem">
          <subItem v-if="activeName === 'subItem'"></subItem>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import all from "./all";
import subItem from "./subItem";
export default {
  components: {
    all,
    subItem,
  },
  data() {
    return {
      activeName: "all",
    };
  },
  methods: {},
};
</script>
<style>
@import url("../../../assets/styles/elementUI.css");
</style>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>